export const type_a = {
    fontFamily: "Funnel Display, serif",
	fontSize: "2rem",
	textTransform: 'capitalize' as const,
	fontWeight: "500"
};

export const type_b = {
	fontFamily: "Inter",
	fontSize: "2rem",
	lineHeight: "1.2"
};

export const type_c = {
	fontFamily: "Inter",
	fontSize: "0.875rem",
	textTransform: 'capitalize' as const,
};

export const type_d = {
	fontFamily: "Inter",
	fontSize: "1rem",
	textTransform: 'capitalize' as const,
};

export const type_e = {
	fontFamily: "Inter",
	fontSize: "1.1rem",
	textTransform: 'capitalize' as const,
};

export const type_f = {
	fontFamily: "Inter",
	fontSize: "0.75rem",
	textTransform: 'capitalize' as const,
};



